import axios from "axios";
import { commonHeadersWeb, getCountryCode } from "./index.js";

export async function putSessionProgress(url, data) {
  const token = localStorage.getItem('token')
  const countryCode = getCountryCode()
  try {
    // const os = `${platform.os.family}`.toLowerCase()
    const res = await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...commonHeadersWeb,
        'ef-user-country-code': countryCode,
        'ef-app-language': sessionStorage.getItem('languageCode')
      },
    });
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}